import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import {
  StyledGroupContainer,
  StyledName,
  StyledGoals,
  StyledNoWinner,
} from './styled';
import { showMobileSidebarSection } from '../../../redux/actions/Team';
import { leagueSetTeamInfo } from '../../../redux/actions/League';
import { POPUPS } from '../../../service/constants';
import { showPopupWindow } from '../../../redux/actions/Popups';
import { getMyCurrentTeam } from '../../../redux/selector/User';

const GroupTeamDesktop = ({ teamData = {}, shortVersion = false, side }) => {
  const dispatch = useDispatch();
  const currentTeam = useSelector(getMyCurrentTeam);
  const { symbol = '', name = '', score = null } = teamData;
  const notScored = score === -1 || score === null;
  const own = Boolean(
    currentTeam?._id && teamData?._id && currentTeam._id === teamData._id
  );
  const showName = name && !shortVersion;
  const showTeamInfo = (id) => {
    if (!id) return;
    const { TEAM_INFO_POPUP } = POPUPS;
    dispatch(leagueSetTeamInfo({ _id: id }, isMobileOnly));
    if (isMobileOnly) {
      dispatch(showMobileSidebarSection('teamInfo'));
    } else {
      dispatch(showPopupWindow(TEAM_INFO_POPUP, TEAM_INFO_POPUP, true));
    }
  };
  return (
    <StyledGroupContainer
      shortVersion={shortVersion}
      side={side}
      $own={own && !shortVersion}
    >
      <StyledName
        onClick={() => showTeamInfo(teamData._id)}
        shortVersion={shortVersion}
      >
        {symbol ? <img src={symbol} alt="team logo" /> : <StyledNoWinner />}
        {showName ? <span>{name}</span> : <></>}
      </StyledName>
      <StyledGoals $pending={notScored} shortVersion={shortVersion} side={side}>
        {notScored ? '?' : score}
      </StyledGoals>
    </StyledGroupContainer>
  );
};

export default GroupTeamDesktop;
